import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Tooltip from "@mui/material/Tooltip";
import React from "react";

interface IncompatibleShiftIconProps {
	title: string;
	size?: number;
}

// Flags a Shift that can't be published until a supervisor edits it
const IncompatibleShiftIcon = ({ title, size = 18 }: IncompatibleShiftIconProps) => (
	<Tooltip title={title} placement='top' disableInteractive>
		<ErrorOutlineOutlinedIcon
			aria-label={title}
			sx={{ fontSize: `${size}px`, color: "warning.main", flexShrink: 0 }}
		/>
	</Tooltip>
);

export default React.memo(IncompatibleShiftIcon);
